<template>
  <div>
    <DialogContainer v-model="dialogObj">
      <template v-slot:dialogSlot>
        <div class="business-body custom-form" v-loading="loading">
          <div class="title-box">
            <el-image :src="cheImage" class="title-label"></el-image>
            基本信息
          </div>
          <el-row class="invice-info">
            <el-col :span="8">
              <span class="label">充值单号：</span>
              <span class="value">{{ form.rechargeNo }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">充值金额：</span>
              <span class="value">{{ numberToThousand(form.rechargeAmount)}}元</span>
            </el-col>
            <el-col :span="8">
              <span class="label">充值对象：</span>
              <span class="value">{{ form.targetName || "-" }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">充值类型：</span>
              <span class="value">
                <span v-if="form.rechargeType === 1">代理商充值</span>
                <span v-if="form.rechargeType === 2">服务商充值</span>
                <span v-if="form.rechargeType === 3">司机充值</span>
              </span>
            </el-col>
            <el-col :span="8">
              <span class="label">充值时间：</span>
              <span class="value">{{ form.rechargeTime || "-" }}</span>
            </el-col>
            <el-col :span="8">
              <span class="label">充值人：</span>
              <span class="value">{{ form.rechargeUserName || "-" }}</span>
            </el-col>
            <el-col :span="24">
              <span class="label">备注：</span>
              <span class="value">{{ form.remark || "-" }}</span>
            </el-col>
          </el-row>
          </div>
      </template>
    </DialogContainer>
  </div>


</template>

<script>
import {numberToThousand} from "@/utils/tool"
import DialogContainer from "@/components/Dialog.vue";
import {detailInfo} from "./api";
export default {
  name: "Detail",
  components: {
    DialogContainer,
  },
  data() {
    return {
      isImmediatelyGetData: false,
      cheImage: require("@/assets/imgs/title.png"),
      imageUrl: require("@/assets/imgs/bg.png"),
      loading: false,
      dialogObj: {
        loading: false,
        btnLoading: false,
        width: "60%",
        show: false,
        title: "详情",
        closeOnClickModal: false,
        confirmFn: null,
        beforeClose: (v) => {
          this.form = this.$options.data().form;
          this.tableData = [];
          if (this.$refs.form) this.$refs.form.resetFields();
          this.dialogObj.show = false;
          this.dialogObj.btnLoading = false;
        },
      },
      form: {},
    };
  },
  mounted() {},
  methods: {
    numberToThousand,
    init(row) {
      this.getDetail(row.rechargeId)
      this.dialogObj.show = true;
    },
    getDetail(rechargeId) {
      this.loading = true;
      detailInfo(rechargeId)
        .then((res) => {
          if (res.code === 200) {
            this.form = res.data;
          }
        })
        .finally((e) => {
          this.loading = false
        });
    },
    // 提交数据
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.dialogObj.btnLoading = true;
          const fileIds = this.form.fileIds
            .map(item => item.fileId);
          const par = {
            rechargeId: this.form.rechargeId,
            fileIds: fileIds,
          };
          handleInvoice(par)
            .then((res) => {
              this.dialogObj.btnLoading = false;
              if (res.code === 200) {
                this.$message.success("处理成功");
                this.$parent.handleAddOrEditSuccess("edit");
                this.dialogObj.beforeClose();
              }
            })
            .catch((e) => {
              this.dialogObj.btnLoading = false;
            });
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.business-body {
  box-sizing: border-box;
  .order-detail-box {
    display: flex;
    width: 100%;
    height: 0.8rem;
    background: #f7fbff;
    padding: 0.1rem;
    border-radius: 0.08rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
    .label-val {
      width: 33.3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      position: relative;
      .label-1 {
        color: #8c8c8c;
        font-size: 0.12rem;
        padding-bottom: 0.06rem;
      }
      .value-1 {
        color: #434343;
      }
    }
    .label-val:after {
      content: "";
      position: absolute;
      right: 0;
      width: 0.01rem;
      height: 0.26rem;
      background: #dce5f5;
    }
    .label-val:nth-last-of-type(1):after {
      display: none;
    }
  }
  .title-box {
    padding: 0rem 0 0.1rem;
    color: #000000;
    .title-label {
      width: 0.08rem;
      height: 0.08rem;
      margin-right: 0.06rem;
    }
  }
  .common-info-box {
    padding: 0.1rem;
    box-sizing: border-box;
    background: #f7f8fb;
    line-height: 0.24rem;
    border-radius: 0.08rem;
  }
  .common-image-box {
    margin-bottom: 0;
    margin-top: 0.04rem;
  }
  .invice-info {
    line-height: 0.3rem;
    margin-bottom: 0.2rem;
  }
  .related-orders {
    background: #f7f8fb;
    border-radius: 0.08rem;
    padding: 0.1rem;
    box-sizing: border-box;
    margin-bottom: 0.2rem;
  }
}
</style>
